import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'angular-toastr/dist/angular-toastr.css';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { rootComponent } from './root.component';
import { app } from './common/app.module';
import { components } from './components/components.module';
import 'angular-auto-validate/dist/jcs-auto-validate.min';
import ngResource from 'angular-resource';
import toastr from 'angular-toastr';
import transitionLoader from 'angular-loading-bar';
import 'angular-loading-bar/build/loading-bar.min.css';
import ngCookies from 'angular-cookies';
import './common/style/_reset.scss';
import './common/style/_mixins.scss';
import './common/style/_variables.scss';
import './common/style/_common.scss';
import Constants from './Constants';

export const root = angular
	.module('root', [
        uiRouter,
        ngResource,
        app,
        components,
        'jcs-autoValidate',
        toastr,
        ngCookies,
        transitionLoader
    ])
    .constant('Constants', new Constants())
    .component('root', rootComponent)
    .config((cfpLoadingBarProvider, $urlRouterProvider, $locationProvider) => {
        'ngInject';

        cfpLoadingBarProvider.includeSpinner = false;
        $urlRouterProvider.otherwise('home');
        $locationProvider.html5Mode(true);
    })

    // cloud ip
    .constant('API_ENDPOINT', 'https://gettherescny.org/api/')

    // local ip
    // .constant('API_ENDPOINT', 'http://191.168.0.128:1340/')
    .name;



// WEBPACK FOOTER //
// ./src/app/root.module.js